
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/warranty-and-refund-policy",
      function () {
        return require("private-next-pages/policies/warranty-and-refund-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/warranty-and-refund-policy"])
      });
    }
  